import React from 'react'
import { useSelector } from 'react-redux';
import ProductsCard from './ProductsCard';



function Search({products}) {
    console.log(products);
    const query = useSelector((state) => state.shopsyReducer.query);
    console.log(query.input);
    console.log(query.length);
    
  const qi = query.length!==0 ? query.input : "SlientCosmo"

  const filteredProducts = products.filter((products)=>{
    
    return products.title.toLowerCase().includes(qi.toLowerCase());
  })

  function display (){
    return console.log(filteredProducts.length);
  }
  display()
  

  return (
    <div className='py-2'>
        { filteredProducts.length !==0 ?
          <p className='mt-0 text-slate-600 pb-3'>Results for <span className='font-semibold'>{query.input}&gt; </span></p>
          : ""
        }
        { filteredProducts.length !== 0 ? "" : 
        <div className="text-center h-screen py-10">
        <p className='text-center text-slate-900'>No results for <span className="font-bold text-center"> 
        {query.input}</span></p></div> }
        
        <div className='max-w-screen-xs grid grid-cols-2 lg:grid-cols-3 gap-3'  >
          
            {
              filteredProducts.map((item)=>(
                <ProductsCard key={item.id} product={item} />
              ))
            }
        </div>
    </div>
  )
}

export default Search
